export default {
  appName: 'Pet Care Note',
  loading: '載入中...',
  loadingPet: '載入寵物資料中...',
  error: '錯誤',
  success: '成功',
  cancel: '取消',
  confirm: '確認',
  save: '儲存',
  delete: '刪除',
  edit: '編輯',
  close: '關閉',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  submit: '提交',
  search: '搜尋',
  filter: '篩選',
  sort: '排序',
  yes: '是',
  no: '否',
  optional: '選填',
  required: '必填',
  add: '新增',
  unknown: '未知',
  
  // Pet species translations
  species: {
    all: '所有類型',
    pets: '隻',
    dog: '狗',
    cat: '貓',
    bird: '鳥',
    fish: '魚',
    rabbit: '兔子',
    hamster: '倉鼠',
    guinea_pig: '天竺鼠',
    reptile: '爬蟲類',
    turtle: '烏龜',
    other: '其他'
  },
  
  // Pet species descriptions
  loyalCompanion: '忠誠的夥伴',
  independentPartner: '獨立的夥伴',
  cleverSinger: '聰明的歌手',
  peacefulWatcher: '安靜的觀察者',
  gentleFriend: '溫柔的朋友',
  livelySprite: '活潑的精靈',
  wiseElder: '智慧的長者',
  specialPartner: '特別的夥伴',
  
  // Time units
  time: {
    years: '年',
    year: '年',
    months: '個月',
    month: '個月',
    days: '天',
    day: '天',
    hours: '小時',
    hour: '小時',
    minutes: '分鐘',
    minute: '分鐘',
    today: '今天',
    tomorrow: '明天'
  },
  
  actions: {
    getStarted: '開始使用',
    learnMore: '了解更多',
    signUp: '註冊',
    signIn: '登入',
    signOut: '登出',
    viewDetails: '查看詳情',
    addNew: '新增',
    add: '新增',
    update: '更新',
    remove: '移除',
    share: '分享',
    download: '下載',
    upload: '上傳',
    refresh: '重新整理',
    retry: '重試',
  },
  
  validation: {
    required: '此欄位為必填',
    invalidEmail: '無效的電子郵件地址',
    invalidPhone: '無效的電話號碼',
    passwordTooShort: '密碼必須至少8個字元',
    passwordsDoNotMatch: '密碼不符',
    invalidDate: '無效的日期',
    invalidUrl: '無效的網址',
  },
  
  messages: {
    saveSuccess: '儲存成功',
    deleteSuccess: '刪除成功',
    updateSuccess: '更新成功',
    errorOccurred: '發生錯誤',
    noData: '無資料',
    confirmDelete: '確定要刪除嗎？',
    unsavedChanges: '您有未儲存的變更。確定要離開嗎？',
    loadingPet: '載入寵物資料中...',
  },
  
  errors: {
    failedToFetch: '無法連接到伺服器，請檢查網路連線'
  },

  seo: {
    home: {
      title: 'Pet Care Note - 全方位寵物健康管理系統 | 簡單追蹤寵物健康狀況',
      description: 'Pet Care Note 讓您輕鬆管理寵物的健康、飲食和照護計劃。追蹤疫苗接種、藥物、獸醫就診記錄，並支援多語言介面（英文、中文、日文）。免費使用，隨時隨地關心您的毛孩。',
      keywords: '寵物健康管理, 寵物記錄, 寵物健康追蹤, 寵物疫苗記錄, 寵物就醫記錄, 寵物照護, 寵物餵食計劃, 多語言寵物應用'
    },
    features: {
      title: '功能特色 - Pet Care Note | 完整的寵物管理工具',
      description: '探索 Pet Care Note 的強大功能：完整寵物檔案、安全分享、健康追蹤、藥物提醒、多語言支援等。您照顧寵物所需的一切工具。',
      keywords: '寵物管理功能, 寵物健康追蹤, 藥物提醒, 獸醫預約, 寵物分享, 多語言寵物應用, 寵物照護工具'
    },
    about: {
      title: '關於我們 - Pet Care Note | 我們的使命與故事',
      description: '了解 Pet Care Note 為全球寵物主人提供最佳寵物健康管理工具的使命。探索我們的故事和對寵物照護卓越的承諾。',
      keywords: '關於寵物健康管理, 寵物照護使命, 寵物健康管理公司, 寵物照護故事, 寵物照護團隊'
    },
    contact: {
      title: '聯絡我們 - Pet Care Note | 獲取支援與解答',
      description: '需要協助或有疑問？聯絡 Pet Care Note 支援團隊。我們隨時為您解答關於寵物健康管理、帳戶問題或功能需求的任何問題。',
      keywords: '聯絡寵物健康管理, 寵物照護支援, 客戶服務, 幫助中心, 寵物照護問題, 技術支援'
    },
    privacy: {
      title: '隱私政策 - Pet Care Note | 您的資料保護',
      description: '閱讀 Pet Care Note 的隱私政策，了解我們如何保護和處理您的個人資訊和寵物資料。您的隱私和安全是我們的首要任務。',
      keywords: '隱私政策, 資料保護, 寵物資料安全, 個人資訊, GDPR 合規, 資料隱私'
    },
    terms: {
      title: '服務條款 - Pet Care Note | 使用者協議',
      description: '查看 Pet Care Note 的服務條款和使用者協議。了解使用我們的寵物健康管理平台時的權利和責任。',
      keywords: '服務條款, 使用者協議, 條款與條件, 服務條款, 法律條款, 使用者權利'
    },
    dashboard: {
      title: '控制台 - Pet Care Note | 管理您的寵物',
      description: '訪問您的 Pet Care Note 控制台，在一個地方查看和管理所有寵物的健康資訊、時程和照護計劃。',
      keywords: '寵物控制台, 寵物管理, 寵物健康總覽, 寵物照護儀表板'
    },
    blog: {
      title: '部落格 - Pet Care Note | 寵物照護技巧與指南',
      description: '探索專業的寵物照護建議、健康提示、訓練指南以及寵物健康的最新資訊。透過 Pet Care Note 的完整部落格保持資訊更新。',
      keywords: '寵物照護部落格, 寵物健康提示, 寵物訓練指南, 寵物健康, 寵物照護建議, 寵物營養, 寵物行為'
    }
  }
};